import { render, staticRenderFns } from "./HomeSectionConstellations.vue?vue&type=template&id=05f4dec6&scoped=true&"
import script from "./HomeSectionConstellations.vue?vue&type=script&lang=ts&"
export * from "./HomeSectionConstellations.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSectionConstellations.vue?vue&type=style&index=0&id=05f4dec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4dec6",
  null
  
)

export default component.exports